﻿import { App, StoreErrorDataEmpty } from '../config/app.js'
import { getError, getErrorMessage, setActionStateMessageForTargets, i18n } from '../helper.js'
const HandleErrors = e =>
{
	if (e && ((e.detail && (e.detail.success || e.detail.canceled)) || e.defaultPrevented))
		return

	if (e instanceof StoreErrorDataEmpty || e?.detail?.error instanceof StoreErrorDataEmpty)
		return // Don't show errors for empty data errors

	if (e.detail?.error?.name == "AbortError")
		return // Don't show error for aborted requests

	const error = getError(e)
	const errorStatus = parseInt(error?.status)

	if (errorStatus == 401 || error?.code == 'access_denied' || error?.meta?.requiredRole == App.Roles.Registered)
	{
		// Redirect on HTTP Status 401 Unauthorized 
		App.UI.AlertError(
			i18n('common.loginrequired'),
			null,
			{
				buttons: {
					ok: {
						label: i18n('common.ok'),
						callback: () =>
						{
							location.href = '/login?ReturnUrl=' + encodeURIComponent(location.pathname + location.search)
						}
					}
				}
			})
		return
	}

	if (e.target && !e.target.dispatchEvent(new ErrorEvent({ error }), e) == true)
		return
	const errorMessage = getErrorMessage(error)

	if (errorMessage)
	{
		let targets = setActionStateMessageForTargets(e.detail?.name, errorMessage, App.cssClass.fail, e.target)
		if (!targets || targets?.length == 0)
			App.UI.AlertError(errorMessage)
	}
	else
	{
		console.warn('Unexpected Error:', e)
	}
}

class ErrorEvent extends Event
{
	constructor(detail, originalEvent)
	{
		super('error', { bubbles: true, cancelable: true })
		this.detail = { error: null, originalEvent: null }
		Object.assign(this.detail, detail)
	}
}

export { ErrorEvent }
export default HandleErrors
